"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allTransferOrderLinesConfirmed = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const allTransferOrderLinesConfirmed = (order) => {
    if (!order)
        return false;
    if (!order.order_lines)
        return false;
    // loop through each order line and check if all versions are confirmed
    let all_confirmed = true;
    order.order_lines
        .filter((x) => {
        return x.type === "TRANSFER";
    })
        .forEach((line) => {
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
        if (!latest_version) {
            all_confirmed = false;
            return;
        }
        // if the latest version is cancelled ignore it
        if (["CANCELLED"].includes(latest_version.status))
            return;
        if (!["CONFIRMED"].includes(latest_version.status))
            all_confirmed = false;
    });
    return all_confirmed;
};
exports.allTransferOrderLinesConfirmed = allTransferOrderLinesConfirmed;
